import React from "react";
import { GiftIcon, RefreshCwIcon, SearchIcon, SettingsIcon, ZapIcon, BoxIcon } from "lucide-react";
import { differentiators } from "../data/content";
import { DifferentiatorIcon } from "../types/content";
const ICONS: Record<DifferentiatorIcon, BoxIcon> = {
  zap: ZapIcon,
  search: SearchIcon,
  settings: SettingsIcon,
  gift: GiftIcon,
  refresh: RefreshCwIcon
};
export function Differentiators() {
  return <section className="bg-carbon px-3 py-4 sm:px-6" data-id="element-30" data-mp="zdslny4ta01j">
      <div className="mx-auto max-w-2xl text-center" data-id="element-31" data-mp="zf3p1wuch5s4">
        <h2 className="font-display text-[1.5rem] font-bold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-32" data-mp="13f41jbxvv6wj">
          THIS ISN'T JUST ANOTHER GENERATOR REPAIR EBOOK
        </h2>
        <p className="mt-1 text-[0.78rem] font-extrabold uppercase tracking-wide text-volt sm:text-[0.95rem]" data-id="element-33" data-mp="1dcs7yz4uq2uj">
          IT'S A READY-TO-USE DIAGNOSTIC SYSTEM.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-34" data-mp="2orf8yqzjwuyu">
          {differentiators.map((item, i) => {
          const Icon = ICONS[item.icon];
          const isLastOdd = i === differentiators.length - 1 && differentiators.length % 2 === 1;
          return <div key={item.title} className={`rounded-md border border-steel/20 bg-graphite px-2.5 py-2 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-35" data-mp="7o0fytjfiy64" data-mpi={i}>
                <h3 className="flex items-center gap-1.5 text-[0.8rem] font-extrabold text-white sm:text-[0.92rem]" data-id="element-36" data-mp="3tuypvsqjc5p2">
                  <Icon className="h-4 w-4 shrink-0 text-volt" strokeWidth={2.25} aria-hidden="true" data-id="element-37" data-mp="3ovm7plalzmst" />
                  {item.title}
                </h3>
                <p className="mt-0.5 text-[0.76rem] leading-[1.35] text-steel sm:text-[0.86rem]" data-id="element-38" data-mp="3k2sxwj0a9o9v">{item.body}</p>
              </div>;
        })}
        </div>
        <p className="mt-2 text-[0.76rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.9rem]" data-id="element-39" data-mp="3b50m3otrsyr8">
          Less random testing. Less unnecessary parts replacement.{' '}
          <span className="text-volt" data-id="element-40" data-mp="315hzt1qe10w0">More diagnostic clarity.</span>
        </p>
      </div>
    </section>;
}